import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPrompt1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="prompt, vibe-designing, box-sparkle"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12.5 7H11.5L10.25 10.25L7 11.5V12.5L10.25 13.75L11.5 17H12.5L13.75 13.75L17 12.5V11.5L13.75 10.25L12.5 7Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPrompt1;
